import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import DynamicSidebar from './DynamicSidebar.jsx';
import Header from './Header.jsx';
import { useHeader } from '../../context/HeaderContext.jsx';

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false); // Mobile sidebar
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false); // Desktop sidebar collapsed
  const { headerConfig } = useHeader();
  
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const toggleSidebarCollapse = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <div className="flex h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-200">
      {/* Sidebar */}
        <DynamicSidebar 
          open={sidebarOpen} 
          collapsed={sidebarCollapsed}
          toggleSidebar={toggleSidebar}
          toggleCollapse={toggleSidebarCollapse}
        />      {/* Main content */}
      <div className="flex flex-col flex-1 overflow-hidden min-w-0">
        <Header 
          toggleSidebar={toggleSidebar}
          pageTitle={headerConfig.pageTitle}
          pageSubtitle={headerConfig.pageSubtitle}
          pageActions={headerConfig.pageActions}
          pageInfo={headerConfig.pageInfo}
        />
        
        <main className="flex-1 overflow-y-auto bg-gray-50 dark:bg-gray-900 transition-colors duration-200">
          {/* Match OrganizationLayout content width and padding for personal workspace */}
          <div className="mx-auto w-full max-w-full md:max-w-[96%] 2xl:max-w-[1600px] px-2.5 sm:px-4 md:px-6 lg:px-8 py-6 min-h-full pl-[max(0.625rem,env(safe-area-inset-left))] pr-[max(0.625rem,env(safe-area-inset-right))]">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;
